import importer from 'common/importer'
const { deloitReq: req } = importer('APIs', null)
/**
 * Quick schedule an appointment
 * - Example -
 * {
 *   "firstName": "string",
 *   "lastName": "string",
 *   "primaryPhone": "string",
 *   "phoneType": "string",
 *   "email": "string",
 *   "appointmentStartDateTime": "2020-06-29T21:07:29.180Z",
 *   "centerId": "string"
 * }
 */
export const scheduleQuickAppointment = (appointment, authToken) => {
  const config = {
    headers: {
      Authorization: authToken
    }
  }
  return req.post('/appointments/schedule-quick-physical', appointment, config)
}
/**
 * Get all apppointments
 */
export const getAllAppointments = (authToken) => {
  return req.get('/appointments', {
    headers: {
      Authorization: authToken
    }
  })
}
/**
 * Get a specific appointment
 * @param {String} id
 */
export const getAppointment = (id, authToken) => {
  return req.get(`/appointments/${id}`, {
    headers: {
      Authorization: authToken
    }
  })
}
/**
 * Reschedule an existing appointment *
 * @param {String} id
 * @param {Object} appointment
 * -
 * - Example -
 * {
 *   "startDateTime": "2020-06-29T21:13:14.499Z",
 *   "modifiedDateTime": "2020-06-29T21:13:14.499Z",
 *   "numberOfChildren": 0,
 *   "appointmentStatus": "MODIFIED",
 *   "lastModifiedBy": "string",
 *   "appointmentType": "DONATION",
 *   "endDateTime": "2020-06-29T21:13:14.499Z",
 *   "subject": "string",
 *   "description": "string",
 *   "durationMinutes": 0
 * }
 */
export const rescheduleAppointment = (id, { rescheduledStartDateTime, donationType, donorSfid, donationCenter, numberOfChildren, createdFrom } = appointment, authToken) => {  
  const data = {
    startDateTime: rescheduledStartDateTime,
    appointmentType: donationType,
    donorSfid: donorSfid,
    centerSfid: donationCenter,
    numberOfChildren: numberOfChildren,
    createdFrom
  }
  const config = {
    headers: {
      Authorization: authToken
    }
  }
  return req.put('/appointments/' + id, data, config)

}

export const scheduleAppointment = (startDateTime, appointmentType, donorSfid, numberOfChildren, centerSfid, createdFrom, authToken) => {
  const data = {
    startDateTime,
    appointmentType,
    donorSfid,
    numberOfChildren: numberOfChildren,
    centerSfid,
    createdFrom
  }
  const config = {
    headers: {
      Authorization: authToken
    }
  }
  return req.post('/appointments', data, config)
}

/**
 * Cancel an existing appointment
 * @param {String} id
 */
export const cancelAppointment = (id, cancelledFrom, authToken) => {
  const config = {
    headers: {
      Authorization: authToken
    }
  }
  const data = {cancelledFrom}
  return req.put(`/appointments/${id}/cancel`, data, config)
}

/* NEW */

/**
 * Donor Calendar View - Available Slot For The Appointment Type and Date Provided
 * @param {String} pdn
 * @param {Number} limit
 * @param {String} appointmentType DONATION | PHYSICAL | PLAYROOM
 */
export const getAvailableSlots = (pdn, limit, appointmentType, authToken) => {
  return req.get('/appointments/donor/available-slots', {
    headers: {
      Authorization: authToken
    },
    params: {
      pdn,
      limit,
      appointmentType
    }
  })
}
/**
 * Get all apppointments
 * @param {String} pdn
 * @param {Number} limit
 * @param {String} appointmentType DONATION | PHYSICAL | PLAYROOM
 */
export const getBookedSlots = (pdn, limit, appointmentType, authToken) => {
  return req.get('/appointments/donor/booked-slots', {
    headers: {
      Authorization: authToken
    },
    params: {
      pdn,
      limit,
      appointmentType
    }
  })
}
/**
 * Create a new appointment
 * - Example -
 * {
 *  "startDateTime": "string",
 *  "pdn": "string",
 *  "centerSfid": "string",
 *  "appointmentType": "DONATION",
 *  "donorSfid": "string",
 *  "appointmentStatus": "string",
 *  "numberOfChildren": 0
 * }
 */
export const createNewAppointment = (appointment, authToken) => {
  const config = {
    headers: {
      Authorization: authToken
    }
  }
  return req.post('/appointments', { ...appointment }, config)
}
/**
 * Validate Appointment
 * @param {String} pdn
 * @param {Number} limit
 * @param {String} appointmentType DONATION | PHYSICAL | PLAYROOM
 */
export const validateAppointment = (pdn, limit, appointmentType, authToken) => {
  return req.get('/appointments/donor/validate-appointment', {
    headers: {
      Authorization: authToken
    },
    params: {
      pdn,
      limit,
      appointmentType
    }
  })
}
/**
 * Get Upcoming Appointments
 * @param {String} donorSfid
 */
export const getUpcomingAppointments = (donorSfid, token) => {
  if (token) {
    return req.get('/appointments/donor/upcoming-appointments', {
      headers: {
        Authorization: token
      },
      params: {
        donorSfid
      }
    })
  } else {
    return req.get('/appointments/donor/upcoming-appointments', {
      params: {
        donorSfid
      }
    })
  }
}

export const checkNewDonorBonusEligibility = (token) => {
  return req.get('appointments/donor/new-donor-bonus-eligibility', {
    headers: {
      Authorization: token
    }
  })
}
/**
 * Update GiftCard Preference
 * @param {Object} giftCardPreference
 * -Example-
 *{
 * "giftCardOptIn": "string"
 * "appointmentid": "integer"
 *}
 */

export const updateGiftCardPreference = (giftCardPreference, authToken) => {
  const config = {
    headers: {
      Authorization: authToken
    }
  }
  return req.patch('/appointments/donor/update-giftcard-options', {...giftCardPreference}, config)
}
